/**
 *
 * ChangePasswordPage
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import injectSaga from '../../utils/injectSaga';
import injectReducer from '../../utils/injectReducer';
import CircularProgress from '@material-ui/core/CircularProgress';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import CssBaseline from '@material-ui/core/CssBaseline';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/styles/withStyles';
/* eslint-disable react/prefer-stateless-function */
import white from '@material-ui/core/colors/common';
import saga from './saga';
import reducer from './reducer';
import { hideLeftDrawer } from '../App/actions';
import _ from 'lodash';

import {
  setHash,
  setUid,
  passwordOnChange,
  passwordConfirmOnChange,
  submitLoginForm,
  authFailure,
} from './actions';
import {
  selectHash,
  selectUid,
  getRegisterSuccess,
  makeSelectPassword,
  makeSelectPasswordConfirm,
  makeSelectLogin,
  makeSelectMessage,
  makeSelectLoading,
  getError,
} from './selectors';

const styles = theme => ({
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    [theme.breakpoints.up(400 + theme.spacing(6))]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(
      3,
    )}px`,
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    marginTop: theme.spacing(1),
  },
  spinner: {
    marginLeft: '20px',
    width: '20px',
    height: '20px',
  },
  submit: {
    marginTop: theme.spacing(3),
  },
});
const SpinnerAdornment = withStyles(styles)(props => (
  <CircularProgress
    className={props.classes.spinner}
    size={20}
    style={{ color: '#fff' }}
  />
));

const AdornedButton = props => {
  const { children, loading, ...rest } = props;
  return (
    <Button {...rest}>
      {children}
      {loading && <SpinnerAdornment {...rest} />}
    </Button>
  );
};

export class ChangePasswordPage extends React.PureComponent {
  componentDidMount() {
    const { key } = this.props.match.params;
    const { uid } = this.props.match.params;

    this.props.setHash(key);
    this.props.setUid(uid);
    this.props.hideSearch();
  }

  render() {
    const {
      loginvisible,
      registersuccess,
      classes,
      loginvalue,
      passwordvalue,
      passwordconfirmvalue,
      message,
      loading,
      error,
    } = this.props;
    const { new_password2, new_password1, non_field_errors, token } = error;

    const errorProps = {
      error: true,
    };

    let sendmessage = '';

    if (registersuccess) {
      sendmessage = 'Ditt lösenord är nu uppdaterat. Logga in';
    }

    return (
      <div>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <Typography variant="headline">Återställ ditt lösenord</Typography>

            <form className={classes.form} onSubmit={this.props.onSubmit}>
              <TextField
                id="password"
                label="Lösenord"
                helperText={new_password1}
                margin="normal"
                FormHelperTextProps={errorProps}
                onChange={this.props.passwordOnChange}
                fullWidth
                value={passwordvalue}
                required
                autoFocus
                type="password"
                disabled={registersuccess}
              />
              <TextField
                id="passwordconfirm"
                label="Bekräfta lösenord"
                helperText={new_password2}
                margin="normal"
                FormHelperTextProps={errorProps}
                onChange={this.props.passwordConfirmOnChange}
                value={passwordconfirmvalue}
                fullWidth
                required
                autoFocus
                type="password"
                disabled={registersuccess}
              />

              {non_field_errors}
              {sendmessage}
              <AdornedButton
                type="submit"
                fullWidth
                loading={loading}
                variant="raised"
                color="primary"
                className={classes.submit}
                disabled={registersuccess}
              >
                Skicka
              </AdornedButton>

              {message}
              {token}
            </form>
          </Paper>
        </main>
      </div>
    );
  }
}

ChangePasswordPage.propTypes = {
  login: PropTypes.string,
  password: PropTypes.string,
  message: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  hash: selectHash(),
  passwordvalue: makeSelectPassword(),
  passwordconfirmvalue: makeSelectPasswordConfirm(),
  error: getError(),
  message: makeSelectMessage(),
  loading: makeSelectLoading(),
  registersuccess: getRegisterSuccess(),
  uid: selectUid(),
});

function mapDispatchToProps(dispatch) {
  return {
    setHash: value => {
      dispatch(setHash(value));
    },
    setUid: value => {
      dispatch(setUid(value));
    },
    passwordOnChange: evt => {
      dispatch(passwordOnChange(evt.target.value));
    },
    passwordConfirmOnChange: evt => {
      dispatch(passwordConfirmOnChange(evt.target.value));
    },
    hideSearch: evt => {
      dispatch(hideLeftDrawer());
    },
    onSubmit: evt => {
      evt.preventDefault();
      evt.stopPropagation();
      dispatch(submitLoginForm());
    },
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withReducer = injectReducer({ key: 'ChangePasswordPage', reducer });
const withSaga = injectSaga({ key: 'ChangePasswordPage', saga });

export default compose(
  withReducer,
  withSaga,
  withConnect,
  withStyles(styles),
)(ChangePasswordPage);
